export const isSuperadminMfaRequired = (data) => Boolean(data?.mfa_required && data?.challenge_id);

export const normalizeSuperadminMfaChallenge = (data = {}) => ({
  challengeId: String(data.challenge_id || ''),
  enrollmentRequired: Boolean(data.enrollment_required),
  qrCode: data.qr_code || '',
  expiresAt: data.expires_at || '',
});

export const buildSuperadminMfaRequest = ({
  challengeId,
  code,
  recoveryCode,
  useRecovery = false,
  enrollmentRequired = false,
} = {}) => {
  if (useRecovery) {
    return {
      path: '/api/superadmin/mfa/recovery/',
      payload: {
        challenge_id: challengeId,
        recovery_code: String(recoveryCode || '').trim(),
      },
    };
  }

  return {
    path: enrollmentRequired
      ? '/api/superadmin/mfa/enroll/confirm/'
      : '/api/superadmin/mfa/verify/',
    payload: {
      challenge_id: challengeId,
      code: String(code || '').trim(),
    },
  };
};

export const getSuperadminMfaErrorMessage = (err) => {
  const status = err?.response?.status;
  if (status === 429) return 'Too many MFA attempts. Please wait before trying again.';
  if (status === 400 || status === 401 || status === 403) {
    return 'The code could not be verified. Please try again.';
  }
  if (!err?.response) return 'MFA verification is unavailable. Please try again.';
  return 'MFA verification failed. Please try again.';
};

